import type {Context} from '../types';
import type {JSONNode} from '@packages/shared/types/JSONNode';

export default function (context: Context) {
  const {jsonNode} = context.node;

  const isCorruptDynamoWrapper =
    jsonNode.type === 'DynamoWrapper' && jsonNode.data?.dyn?.type !== 'wrapper';

  const isCorruptDynamoList =
    jsonNode.type === 'DynamoList' && jsonNode.data?.dyn?.type !== 'list';

  const isCorruptDynamoItem =
    jsonNode.type === 'DynamoItem' && jsonNode.data?.dyn?.type !== 'item';

  const isCorruptDynamoEmpty =
    jsonNode.type === 'DynamoEmpty' && jsonNode.data?.dyn?.type !== 'empty';

  const needed =
    isCorruptDynamoWrapper ||
    isCorruptDynamoList ||
    isCorruptDynamoItem ||
    isCorruptDynamoEmpty;

  return {
    needed,
    logData: {
      msg: 'Dynamo plugin node is missing `node.data.dyn.type`',
      meta: {
        nodeId: jsonNode._id,
      },
    },
    apply: () => {
      if (isCorruptDynamoWrapper) {
        setDataDynType(jsonNode, 'wrapper');
      } else if (isCorruptDynamoList) {
        setDataDynType(jsonNode, 'list');
      } else if (isCorruptDynamoItem) {
        setDataDynType(jsonNode, 'item');
      } else if (isCorruptDynamoEmpty) {
        setDataDynType(jsonNode, 'empty');
      }
    },
  };
}

function setDataDynType(
  jsonNode: JSONNode,
  type: 'wrapper' | 'list' | 'item' | 'empty'
): void {
  if (!jsonNode.data) {
    jsonNode.data = {};
  }
  if (!jsonNode.data.dyn) {
    jsonNode.data.dyn = {};
  }
  jsonNode.data.dyn.type = type;
}
